import { useEffect, useRef, useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  firestoreTimestampToDate,
  formatString,
  getDeviceType,
} from "../util";
import { useAuth } from "../../../../../../providers/auth";
import {
  updateUserBookmarks,
  getUserBookmarks,
} from "../../../../../../data/user";
import { applyNowMetric } from "../../../../../../callable-cloud-functions/cloudFunctions";
import { sanitizeMarkup } from "../../../../../../util/sanitization/sanitize-html";
import DialogWrapper from "../../../../../custom-ui/dialog/Dialog";
import useModal from "../../../../../../hooks/useModal";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import SliderWithCheckbox from "../../../../../custom-ui/old-ui/SliderWithCheckbox";
import { cn } from "../../../../../../util/cn";
import Resume from "../../../onboarding/Resume";
import PayRateForJobDetails from "../../../../../JobDetailsCom/PayRateForJobDetails";
import PayRateTiles from "../../../../../JobDetailsCom/PayRateTiles";
import ApplyConfirmation from "../../../../../JobDetailsCom/ApplyConfirmation";
import EmojiFlagText from "../../../../../custom-ui/emoji/EmojiFlagText";
import AppliedTag from "../../../../../JobDetailsCom/AppliedTag";



const JobsDetails = ({
  jobsDetailData,
  bookmarks,
  setBookmarks,
  aspectsOfJobMappedWithCode,
  applyConfirmationSentTag,
  setApplyConfirmationSentTag

}) => {
  const data = useAuth();
  const { isShowing, toggle: toggleShow } = useModal();

  const [loading, setLoading] = useState(false);
  const [resumeUploadedSucc, setResumeUploadedSucc] = useState(false);
  const [applyConfirmationSent, setApplyConfirmationSent] = useState(false);


  useEffect(() => {
    setApplyConfirmationSent(false)

  }, [jobsDetailData])



  const commissionRef = useRef(null);
  useEffect(() => {
    const fetchBookmarks = async () => {
      const userBookmarks = await getUserBookmarks(data?.user?.id);
      setBookmarks(userBookmarks);
    };
    fetchBookmarks();
  }, [data]);

  const {
    companyLogo,
    companyFullName,
    jobName,
    openings,
    workType,
    // workTerm
    isSeasonal,
    isApplied,
    hybridJobLocation,
    workSettings,
    payRate,
    startDateInclude,
    applicationFlow,
    jobDescription,
    solutionType,
    hoursPerWeek,
    noATS,
    isOconus,
    isEquipmentProvider,
    startDate,
  } = jobsDetailData || {};

  const platform = getDeviceType();

  const appliedDate = jobsDetailData?.appliedAt
    ? (() => {
      const date = firestoreTimestampToDate(jobsDetailData.appliedAt);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    })()
    : null;

  const date = new Date(startDate?.seconds * 1000);
  const options = { month: "short", year: "numeric" };
  const formattedDate = date
    .toLocaleDateString("en-US", options)
    .replace(" ", " ");

  const handleApplyJobs = async () => {
    setApplyConfirmationSent(true);
    setLoading(true);
    window.open(applicationFlow, "_blank");
    try {
      await applyNowMetric({
        jobId: jobsDetailData?.id,
        userId: data?.user?.id,
        name: data?.user?.name || "",
        email: data?.user?.email || "",
        phone: data?.user?.phone || "",
        platform: platform,
        solutionType: solutionType === "job_board" ? "DH" : "BPO",
      });
      setLoading(false);
      toggleShow();
    } catch (error) {
      console.error("Error applying for the job:", error);
    }
  };

  const handleBookMark = async () => {
    await updateUserBookmarks(data?.user?.id, jobsDetailData?.id);

    // Update local bookmarks state
    setBookmarks((prevBookmarks) => {
      if (
        Array.isArray(prevBookmarks) &&
        prevBookmarks.some((bookmark) => bookmark.jobId === jobsDetailData?.id)
      ) {
        return prevBookmarks.filter(
          (bookmark) => bookmark.jobId !== jobsDetailData?.id,
        );
      } else {
        return [
          ...prevBookmarks,
          { jobId: jobsDetailData?.id, createdAt: new Date() },
        ];
      }
    });
  };

  const scrollToCommission = () => {
    commissionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  return (
    <div
      style={{
        scrollbarWidth: "thin",
        scrollbarColor: "#b3b3b3 #f0f0f0",
      }}
      className="w-full mx-auto bg-white   rounded-lg overflow-y-auto overflow-x-hidden h-[92%] xs:h-ful md:h-fulll p-6 xs:p-4 md:p-4 xs:mt-0 md:mt-0 mt-12"
    >
      {/* Header Section */}
      {jobsDetailData ? (
        <>
          <div className="flex justify-between xs:flex-col md:flex-col items-start">
            <div className="flex">
              <div className="mr-4">
                <img
                  src={
                    solutionType == "bpo"
                      ? "/images/InstantTeamsIcon-05.png"
                      : companyLogo || "/images/company-placeholder.png"
                  }
                  alt="Company Logo"
                  className="w-16 h-16 rounded object-contain "
                />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-instant-teams-blue-Main">
                  <EmojiFlagText>{jobName}</EmojiFlagText>
                </h2>
                <p className="text-gray-500 text-sm font-thin">
                  {solutionType == "bpo" ? "Instant Teams" : companyFullName}
                </p>
              </div>
            </div>
            <div className="flex xs:mt-2 md:mt-2  items-center space-x-4">
              {openings > 1 && (
                <span className="bg-instant-teams-teal-D2 xs:hidden md:hidden text-gray-600 text-xs px-3 py-1 rounded-full">
                  Multiple Openings
                </span>
              )}
              {isSeasonal && (
                <span
                  className="xs:hidden md:hidden text-gray-600 text-xs px-3 py-1 rounded-full"
                  style={{ backgroundColor: "#C5FFBC" }}
                >
                  Seasonal
                </span>
              )}
              {isOconus && (
                <span
                  className="xs:hidden md:hidden text-gray-600 text-xs px-3 py-1 rounded-full"
                  style={{ backgroundColor: "#d9e1fd" }}
                >
                  OCONUS
                </span>
              )}
              {/* Bookmark Icon */}
              <div className="flex-shrink-0 bg-gray-100 xs:mt-2 md:mt-2 flex items-center justify-center w-[50px] h-[50px] rounded-full ml-4 ">
                <button
                  onClick={handleBookMark}
                  className="text-gray-500 pl-[14px] pt-[14px] hover:text-gray-600"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 42 42"
                    stroke="currentColor"
                    className="w-8 h-8"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      fill={
                        Array.isArray(bookmarks) &&
                          bookmarks.some(
                            (bookmark) => bookmark.jobId === jobsDetailData?.id,
                          )
                          ? "#19405E"
                          : ""
                      }
                      d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3-7 3V5z"
                    />
                  </svg>
                </button>
              </div>




              <button
                onClick={toggleShow}
                className="bg-instant-teams-blue-Main text-white py-[16px] px-[34px] rounded-full flex items-center text-[16px]"
              >
                <span className="w-[107px]">
                  Apply Now{" "}
                  <FontAwesomeIcon icon={faExternalLinkAlt} className="ml-2" />
                </span>
              </button>
            </div>
          </div>
          <div className="flex w-full justify-between items-start">
            <div className="mt-4 flex flex-row flex-wrap items-stretch gap-3 xs:mt-8 md:mt-8">
              <div className="bg-[#1F385133] w-[170px] min-w-[170px] py-2 px-4 rounded-lg flex flex-col items-center text-center">
                <p className="text-instant-teams-blue-Main text-sm leading-5 min-h-[20px]">
                  Work Type
                </p>
                <p className="font-semibold text-instant-teams-blue-Main leading-6 min-h-[24px]">
                  {formatString(workType)}
                </p>
                <p className="text-instant-teams-blue-Main text-xs leading-4 min-h-[16px]">
                  {workType === "part_time"
                    ? `${hoursPerWeek.min} - ${hoursPerWeek.max} hours/week`
                    : "\u00A0"}
                </p>
              </div>

              <div className="bg-[#15415E33] w-[170px] min-w-[170px] py-2 px-4 rounded-lg flex flex-col items-center text-center">
                <p className="text-instant-teams-blue-Main text-sm leading-5 min-h-[20px]">
                  Work Setting
                </p>
                <p className="font-semibold text-instant-teams-blue-Main leading-6 min-h-[24px]">
                  {formatString(workSettings)}
                </p>
                <div className="relative group w-full min-h-[16px]">
                  {workSettings === "hybrid" && hybridJobLocation ? (
                    <>
                      <p className="text-instant-teams-blue-Main text-xs leading-4 truncate cursor-context-menu">
                        {hybridJobLocation.length > 15
                          ? hybridJobLocation.slice(0, 15) + "..."
                          : hybridJobLocation}
                      </p>
                      <div className="absolute z-10 w-max max-w-xs bg-[#f9f6f6] shadow-lg text-black text-xs rounded-md px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none left-1/2 -translate-x-1/2 top-full mt-1">
                        {hybridJobLocation}
                      </div>
                    </>
                  ) : (
                    <p className="text-xs leading-4">{"\u00A0"}</p>
                  )}
                </div>
              </div>

              {startDateInclude && (
                <div className="bg-[#026AAF33] w-[170px] min-w-[170px] py-2 px-4 rounded-lg flex flex-col items-center text-center">
                  <p className="text-instant-teams-blue-Main text-sm leading-5 min-h-[20px]">
                    Start Date
                  </p>
                  <p className="font-semibold text-instant-teams-blue-Main leading-6 min-h-[24px]">
                    {formattedDate}
                  </p>
                  <p className="text-xs leading-4 min-h-[16px]">{"\u00A0"}</p>
                </div>
              )}

              <PayRateTiles payRate={payRate} />
            </div>
            {(isApplied || applyConfirmationSentTag?.jobId === jobsDetailData?.id) &&
              <div className="flex ">
                <AppliedTag appliedDate={appliedDate} isFromJobDetails={true} />
              </div>}
            {applyConfirmationSent && !(isApplied || applyConfirmationSentTag?.jobId === jobsDetailData?.id) && <div className="  flex items-center bg-white shadow-xl mt-4 justify-start   rounded-lg py-1 px-7">
              <ApplyConfirmation jobData={jobsDetailData} setApplyConfirmationSent={setApplyConfirmationSent} setApplyConfirmationSentTag={setApplyConfirmationSentTag} />
            </div>}


          </div>

          {/* Job Description */}
          <div className="mt-6 border-t pt-6">
            {jobDescription?.whatsInItForYou === null &&
              jobDescription?.dayInLife && (
                <div className="mt-4 mb-[20px]">
                  <p className="font-[Gilroy-SemiBold] font-[400] text-[20px] leading-[24.5px] text-[#15415E]">
                    Job Summary
                  </p>
                  <div className="mt-[5px] font-[Gilroy-Medium] font-[400] text-[16px] leading-[23px] text-gray-500 emoji-flag-polyfill-text">
                    {jobDescription?.dayInLife}
                  </div>
                </div>
              )}
            <PayRateForJobDetails payRate={payRate} />
            {jobDescription?.whatsInItForYou === null ? (
              <div className="flex flex-col">
                <p className="font-[Gilroy-SemiBold] font-[400] text-[20px] leading-[24.5px] text-[#15415E]">
                  Why Work Here
                </p>
                <div className="mt-[20px] flex flex-row gap-[20px] flex-wrap">
                  {jobDescription?.aspectsOfJob.map((aspectsOfJobCode) => {
                    return (
                      <div
                        key={aspectsOfJobMappedWithCode[aspectsOfJobCode]?.id}
                        className="bg-[#F4F7F8] py-[16px] px-[24px] rounded-[70px] font-[Gilroy-SemiBold] font-[400] text-[16px] leading-[19.6px] text-[#373737]"
                      >
                        {aspectsOfJobMappedWithCode[aspectsOfJobCode]?.label}
                      </div>
                    );
                  })}
                  {isOconus && (
                    <div className="bg-[#F4F7F8] py-[16px] px-[24px] rounded-[70px] font-[Gilroy-SemiBold] font-[400] text-[16px] leading-[19.6px] text-[#373737]">
                      OCONUS Friendly
                    </div>
                  )}
                  {isEquipmentProvider && (
                    <div className="bg-[#F4F7F8] py-[16px] px-[24px] rounded-[70px] font-[Gilroy-SemiBold] font-[400] text-[16px] leading-[19.6px] text-[#373737]">
                      Equipment Provided
                    </div>
                  )}
                </div>
                {isEquipmentProvider && <p className="mt-[30px] font-[Gilroy-SemiBold] font-[400] text-[16px] leading-[24.5px] text-[#15415E]">
                  We bring the remote opportunity—and the equipment. This role
                  includes all the tools you need to succeed, sent straight to
                  your door.
                </p>}
                {jobDescription?.aspectsOfJobOther && (
                  <div
                    className={cn(
                      "font-[Gilroy-Medium] font-[400] text-[16px] leading-[23px] text-[#373737] emoji-flag-polyfill-text",
                      {
                        "mt-[30px]": jobDescription?.aspectsOfJob.length > 0,
                      },
                    )}
                  >
                    {jobDescription?.aspectsOfJobOther}
                  </div>
                )}
              </div>
            ) : (
              <>
                <div>
                  <h1 className="text-instant-teams-teal-Main">
                    What's in it for you?
                  </h1>
                </div>
                <p className="text-gray-600 text-sm mt-2 leading-relaxed">
                  <div
                    className="dangerously list-inside pl-0 ml-0 emoji-flag-polyfill-text"
                    dangerouslySetInnerHTML={sanitizeMarkup(
                      jobDescription?.whatsInItForYou,
                    )}
                  ></div>
                </p>
              </>
            )}

            {
              // jobDescription?.dayInLife === null
              jobDescription?.aboutThisJob &&
                jobDescription?.aboutThisJob.length > 0 ? (
                <div className="flex xs:w-full flex-col mt-[30px]">
                  <p className="font-[Gilroy-SemiBold] font-[400] text-[20px] leading-[24.5px] text-[#15415E]">
                    Instant Job Insights
                  </p>
                  <div className="w-2/3 pl-[10px]">
                    {jobDescription?.aboutThisJob.map((option) => {
                      return (
                        <SliderWithCheckbox
                          key={option.code}
                          option={option}
                          value={option.value}
                          isChecked={true}
                          onSelectionChange={() => { }}
                          isViewOnly={true}
                        />
                      );
                    })}
                  </div>
                </div>
              ) : (
                <>
                  {jobDescription?.dayInLife && (
                    <div className="mt-4">
                      <h3 className="text-instant-teams-teal-Main mb-2">
                        A Day in the Life
                      </h3>
                      <p className="text-gray-500 text-sm">
                        <div
                          className="dangerously text-sm emoji-flag-polyfill-text"
                          dangerouslySetInnerHTML={sanitizeMarkup(
                            jobDescription?.dayInLife,
                          )}
                        ></div>
                      </p>
                    </div>
                  )}
                </>
              )
            }

            {jobDescription?.mustHaves === null ? (
              <div className="flex flex-col mt-[30px]">
                <p className="font-[Gilroy-SemiBold] font-[400] text-[20px] leading-[24.5px] text-[#15415E]">
                  Must Haves for Success
                </p>

                <div className="mt-[20px] flex flex-row gap-[20px] flex-wrap justify-start">
                  {jobDescription?.mustHavesCheckboxes.map((mustHavesCode) => {
                    return (
                      <div key={mustHavesCode}>
                        <img
                          src={`/images/must-haves-images/${mustHavesCode}.png`}
                          alt="Image"
                          className="w-[150px] h-auto"
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <>
                {jobDescription?.mustHaves && (
                  <div className="mt-4">
                    <h3 className="text-instant-teams-teal-Main mb-2">
                      Must Haves/What You Bring to the Table
                    </h3>
                    <p className="text-gray-500 text-sm">
                      <div
                        className="dangerously emoji-flag-polyfill-text"
                        dangerouslySetInnerHTML={sanitizeMarkup(
                          jobDescription?.mustHaves,
                        )}
                      ></div>
                    </p>
                  </div>
                )}
              </>
            )}
          </div>
        </>
      ) : (
        <div className="flex items-center justify-center  h-full  ">
          <h1 className="text-2xl text-gray-400 "> Select a Job</h1>
        </div>
      )}

      {isShowing && (
        <DialogWrapper
          size={
            jobsDetailData?.noATS ? "w-[50vw] xs:w-[95vw] h-auto" : "max-w-md"
          }
          displayCloseIcon={true}
          onClose={toggleShow}
        >
          {/* Sticky Header */}
          <div className="w-full sticky top-0 bg-white z-10 px-4 py-3 flex justify-between items-center ">
            <h1 className="text-instant-teams-blue-Main text-xl font-semibold">
              {noATS == true
                ? "Connect Directly with this Employer"
                : "Apply Now"}
            </h1>
            <div
              className="flex justify-center items-center w-7 h-7 bg-gray-200 rounded-full cursor-pointer"
              onClick={toggleShow}
            >
              <FontAwesomeIcon icon={faTimes} color="#565656" />
            </div>
          </div>

          {/* Scrollable Content */}
          <div
            className="overflow-y-auto px-4 py-3 no-scrollbar "
            style={{ maxHeight: "calc(90vh - 56px)" }}
          >
            {noATS !== true ? (
              <div className="p-3">
                <p className="text-[14px] text-gray-600">
                  Thank you for exploring career opportunities with Instant
                  Teams! We proudly offer customer experience (CX) roles within
                  our own teams and partner with amazing brands to connect you
                  with additional opportunities. If you don’t find the perfect
                  fit today, be sure to check back often.
                </p>
                <p className="text-[14px] mt-4 text-gray-600">
                  You’ll now be redirected to the application stage for this
                  position, which will open in a new tab. Please ensure your
                  popup blocker settings allow the page to open. Note that
                  external sites may have privacy policies different from the
                  Instant Teams Marketplace. We appreciate your trust as you
                  navigate your career journey!
                </p>
                <div className="w-full flex justify-center items-center">
                  <button
                    onClick={handleApplyJobs}
                    className={`py-2 px-8 text-white mt-8 font-medium rounded-full w-[200px] h-12 ${loading ? "bg-gray-400" : "bg-[#15415E]"
                      }`}
                  >
                    {loading ? "..." : "Continue"}
                  </button>
                </div>
              </div>
            ) : (
              <div className=" p-3">
                <p className="text-instant-teams-blue-Main mb-2 text-lg font-bold">
                  Company Name
                </p>
                <p className="text-gray-400 text-base mb-3">
                  {companyFullName}
                </p>
                <hr className="w-full" />
                <p className="text-instant-teams-blue-Main mb-2 mt-3 text-lg font-bold">
                  Job Title
                </p>
                <p className="text-gray-400 text-base mb-3">
                  <EmojiFlagText>{jobName}</EmojiFlagText>
                </p>
                <hr className="w-full" />
                <Resume
                  userId={data?.user?.id}
                  deviceType={platform}
                  handleDone={toggleShow}
                  setResumeUploadedSucc={setResumeUploadedSucc}
                  jobData={jobsDetailData}
                />
              </div>
            )}

            {/**
             * Resume upload confirmation modal
             */}
          </div>
        </DialogWrapper>
      )}

      {resumeUploadedSucc && (
        <DialogWrapper size="max-w-lg">
          <>
            <div className=" w-full flex flex-col items-center  justify-center p-4">
              <div>
                <img className="w-20 h-20" src="/images/publish_job.png" />
              </div>
              <h1 className=" text-[24px] text-instant-teams-blue-Main font-semibold  mt-4">
                Application Sent!
              </h1>
              <p className=" text-[18px] text-center mt-2 mb-2 text-gray-600">
                Your email application has been successfully delivered directly
                to our hiring partner.
              </p>
              <p className="text-[13.5px] my-2 text-gray-500 text-center">
                Please note: Due to limited capacity, we aren’t able to provide
                individual updates at this time for direct applications outside
                of Instant Teams. We recommend following the brand on social
                media and checking back regularly for new opportunities.
              </p>

              <p className=" my-3 text-[#626060] font-semibold text-center">
                Thanks for taking the next step—you're on the radar!
              </p>

              <button
                onClick={() => {
                  setResumeUploadedSucc(false);
                }}
                className="bg-instant-teams-blue-Main px-16 py-2 rounded-full text-white mt-4"
              >
                Done
              </button>
            </div>
          </>
        </DialogWrapper>
      )}
      {/* <ToastAlert /> */}
    </div>
  );
};

export default JobsDetails;
